export { ColoredIcon } from "./MultiColor/MultiColorIcon";
export { Icon } from "./SingleColor/SingleColorIcon";
